import { SsrContext } from '@fergdigitalcommerce/fergy-react-components';
import { useContext, type FunctionComponent, type PropsWithChildren } from 'react';

type Props = {
	code: number;
};

/**
 * This component allows you to set a response status code from within
 * a component during a server side render. Useful for returning status
 * codes of 404 when the data for a valid route is not found.
 * Ex: Invalid Product Id
 */
export const Status: FunctionComponent<PropsWithChildren<Props>> = ({ code, children }) => {
	const ssrContext = useContext(SsrContext);
	ssrContext.statusCode = code;
	return children;
};
